/**
 * 오늘의 브리핑 집계 유틸 (Phase 2-A, 2026-08-18).
 */

/**
 * by-tool API 응답의 tools 배열을 engine 기준으로 합산하여
 * requestCount 내림차순 Top 1 엔진을 반환한다.
 *
 * - 동일 engine의 requestCount를 합산 (tool은 무시)
 * - 동률 시 engine 이름 오름차순(deterministic)
 * - 빈 engine("")은 "default"로 취급
 *
 * @param {Array} tools - by-tool API의 tools 배열 [{tool, engine, requestCount, ...}]
 * @returns {{ engine: string, requestCount: number } | null}
 */
export function topEngineByRequests(tools) {
  if (!tools || tools.length === 0) return null;

  const map = new Map(); // engine → totalRequestCount
  for (const row of tools) {
    const engine = row.engine || "default";
    const count = row.requestCount || 0;
    map.set(engine, (map.get(engine) || 0) + count);
  }

  let best = null;
  for (const [engine, requestCount] of map.entries()) {
    if (
      !best ||
      requestCount > best.requestCount ||
      (requestCount === best.requestCount && engine < best.engine)
    ) {
      best = { engine, requestCount };
    }
  }

  return best;
}
